import { Component, OnInit,Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef,MatDialog } from "@angular/material";
import { ServerService } from 'src/app/services/server.service';
import { HttpClient } from '@angular/common/http';
import { ClipBoardService as messageService} from 'src/app/services/clipboard.service';
import { DeleteAttachmentComponent } from '../delete-attachment/delete-attachment.component';
@Component({
  selector: 'app-campaign-attachments',
  templateUrl: './campaign-attachments.component.html',
  styleUrls: ['./campaign-attachments.component.scss']
})
export class CampaignAttachmentsComponent implements OnInit {
  authToken = localStorage.getItem('token')
  adminUser:any;
  selectedUser:any;
  brochureFiles: File[] = [];
  brochurePreviewUrls: (string | ArrayBuffer)[] = [];
  creativeFiles: File[] = [];
  creativePreviewUrls: (string | ArrayBuffer)[] = [];
  mediaFiles: File[] = [];
  mediaPreviewUrls: (string | ArrayBuffer)[] = [];
  currentDate: Date = new Date();
  fileType:any;
  brochures:any
  creative_attachments:any;
  media_plan_attachments:any;
  userInfo = JSON.parse(localStorage.getItem('userInfo'));
  allData:any;
  btnStatus = false;
  deleteAttachmentComponent:MatDialogRef<DeleteAttachmentComponent>;
  // showOverlay = false;
  previewImageUrl: string | null = null;
  showComponentLoader = true;
  constructor(
    private dialogRef: MatDialogRef<CampaignAttachmentsComponent>,
    private _serverService:ServerService,
    private http:HttpClient,
    private dialog:MatDialog,
    private clipBoardMessageService:messageService,
    @Inject(MAT_DIALOG_DATA) public data
  ) { 
    localStorage.setItem('deleteAttachment','false')
    this.allData = this.data;
    this.brochures = this.data.brochure;
    // console.log(this.brochures)
    // console.log(this.data)
    this.creative_attachments = this.data.creative_attachment
    this.media_plan_attachments = this.data.media_plan_attachment
    this.showComponentLoader = false
    // console.log(this.brochures)
  }

  ngOnInit() {
    // console.log(this.data)
    // this.getAllVendorAdmin()
  }
 
  onFileSelected(event: Event, container: string): void {
    this.fileType = '';
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const files = Array.from(input.files);
    
      const MAX_FILE_SIZE = 100 * 1024 * 1024;
      // console.log(files)
      // if (files[0].size > MAX_FILE_SIZE) {
      //   this.clipBoardMessageService.showMessgeInText("Max file size allowed is 100MB", "error-snackbar")
      //   return; 
      // }
      files.forEach(file => {

        if (file.size > MAX_FILE_SIZE) {
          // Show error message and skip this file
          this.clipBoardMessageService.showMessgeInText(
            `File "${file.name}" exceeds the maximum allowed size of 100MB.`,
            'error-snackbar'
          );
          input.value = '';
          return;
        }
        // console.log(file)
        const reader = new FileReader();
        reader.onload = () => {
          switch (container) {
          
            case 'brochure':
              this.brochureFiles.push(file);
            
              this.brochurePreviewUrls.push(reader.result);
              
              break;
            case 'creative':
              this.creativeFiles.push(file);
              this.creativePreviewUrls.push(reader.result);
              break;
            case 'media':
              this.mediaFiles.push(file);
              this.mediaPreviewUrls.push(reader.result);
              break;
            default:
              break;
          }
        };
        reader.readAsDataURL(file);
      });
      input.value = '';
      // console.log(this.brochureFiles)
    }
  }

  discardFile(index: number, container: string): void {
    switch (container) {
      case 'brochure':
        this.brochureFiles.splice(index, 1);
        this.brochurePreviewUrls.splice(index, 1);
        break;
      case 'creative':
        this.creativeFiles.splice(index, 1);
        this.creativePreviewUrls.splice(index, 1);
        break;
      case 'media':
        this.mediaFiles.splice(index, 1);
        this.mediaPreviewUrls.splice(index, 1);
        break;
      default:
        break;
    }
  }


  close() {
    this.dialogRef.close();
}

apply() {
  this.showComponentLoader = true;
  this.btnStatus = true
  const formData: FormData = new FormData();
//   for (var x = 0; x < this.brochureFiles.length; x++) {
//     formData.append("brochure[]", this.brochureFiles[x]);
// }
// for (var x = 0; x < this.mediaFiles.length; x++) {
//   formData.append("media_plan_attachment[]", this.mediaFiles[x]);
// }
// for (var x = 0; x < this.creativeFiles.length; x++) {
//   formData.append("creative_attachment[]", this.creativeFiles[x]);
// }
const appendFiles = (files: File[], fieldName: string) => { files.forEach(file => formData.append(fieldName, file)); };
 appendFiles(this.brochureFiles, "brochure[]");
  appendFiles(this.mediaFiles, "media_plan_attachment[]");
   appendFiles(this.creativeFiles, "creative_attachment[]");


  let url = this.data.id
  // Send formData to server
  this._serverService.updateCampaignDetails(url,formData, this.authToken).subscribe(response => {
    this.clipBoardMessageService.showMessgeInText("File Attached Succesfully", "success-snackbar")
    this.dialogRef.close(response);
    this.showComponentLoader = false;
  }, error => {
    console.error('Upload failed', error);
    this.btnStatus = false
  });
}
openFullPreview(links:any){

  // openFullPreview(links: any) {
    const fileUrl = links;
    // console.log(fileUrl)
    const fileExtension = fileUrl.name.split('.').pop().toLowerCase();
    // console.log(fileExtension)
  
    switch (fileExtension) {
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        // Open image in a new tab
        this.previewImageUrl = fileUrl.link;
        // console.log(fileUrl.link)
        window.open(this.previewImageUrl, '_blank');
        break;
  
      case 'mp4':
      case 'webm':
      case 'ogg':
        // Open video in a new tab
        this.previewImageUrl = fileUrl.link;
        const videoHtml = `<video width="100%" height="100%" controls autoplay>
                             <source src="${this.previewImageUrl}" type="video/${fileExtension}">
                             Your browser does not support the video tag.
                           </video>`;
        const videoWindow = window.open("", "_blank");
        if (videoWindow) {
          videoWindow.document.write(videoHtml);
        }
        break;
  
      case 'pdf':
        // Open PDF in a new tab
        this.previewImageUrl = fileUrl.link;
        window.open(this.previewImageUrl, '_blank');
        break;
  
     
      case 'xls':
      case 'xlsx':
      case 'doc':
      case 'docx':
        case 'ppt':
    case 'pptx':
      
        // Open these files in Google Docs or a new tab depending on the format
        this.previewImageUrl = `https://docs.google.com/gview?url=${encodeURIComponent(fileUrl.link)}&embedded=true`;
        window.open(this.previewImageUrl, '_blank');
        break;
        case 'csv':
      // Directly open the CSV file
      window.open(fileUrl.link, '_blank');
      break;
      default:
        // Handle other file types or show a message
        alert('File type not supported for preview.');
        break;
    }
  // }
  

}
download(url:any,filename:any){
  this.http.get(url, { responseType: 'blob' }).subscribe(blob => {
    const link = document.createElement('a');
    const objectUrl = URL.createObjectURL(blob);
    link.href = objectUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(objectUrl);  // Clean up
  });
  
}
closeOverlay(){
  // this.showOverlay = false;
  this.previewImageUrl = null
}
deleteModal(item:any,type:any){
    item['campaign_id'] = this.allData.id;
    
    item['type_of_attachment'] = type;
    this.deleteAttachmentComponent = this.dialog.open(DeleteAttachmentComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '520px',
      panelClass: 'blue-snackbar',
      data: item
    });
    this.deleteAttachmentComponent.afterClosed().subscribe(result => {
      // console.log(result)
      if(result != undefined){
        if(result.type_of_attachment == 'brochure'){
          localStorage.setItem('deleteAttachment','true')
          // console.log(this.brochures)
       this.brochures =  this.brochures.filter((brochure)=>brochure.id !== result.id)
      //  console.log(this.brochures)
        }
        else if(result.type_of_attachment == 'creative'){
          localStorage.setItem('deleteAttachment','true')
          this.creative_attachments =  this.creative_attachments.filter((creative)=>creative.id != result.id)
        }
        else if(result.type_of_attachment == 'media_plan'){
          localStorage.setItem('deleteAttachment','true')
          this.media_plan_attachments =  this.media_plan_attachments.filter((media_plan)=>media_plan.id != result.id)
        }
    
        // console.log("hi")
      }
      // console.log(this.brochures)
    });
    
  

}
}